import moment from 'moment'

export function formatDate(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY')
  }
}

export function formatDateTime(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
}

export function formatDateTimeWithSeconds(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm:ss')
  }
}
